import * as yup from 'yup';
import 'yup-phone';

const amountSchema = yup.object().shape({
  amount: yup.string().required('Mandatory amount field!')
});

export { amountSchema };
